import React, { createContext, useState, useContext, ReactNode, useEffect } from "react";
import { Product } from "../@types/Product";

interface CartContextType {
  cartItems: Product[];
  addToCart: (product: Product, quantity: number) => void;
  removeFromCart: (productId: number) => void;
  setCartItems: (items: Product[]) => void;
}

interface CartProviderProps {
  children: ReactNode;
}

const CartContext = createContext<CartContextType | undefined>(undefined);


export const CartProvider: React.FC<CartProviderProps> = ({ children }) => {
  const [cartItems, setCartItems] = useState<Product[]>([]);

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);
  

  const addToCart = async (product: Product, quantity: number) => {
    try {
      // Asegurarnos de que el producto tenga imagen
      let productWithImage = { ...product };
      // if (!product.image) {
      //   try {
      //     const image = await ProductService.getProductImage(product.sku);
      //     productWithImage.image = image || ""; // Imagen por defecto
      //   } catch {
      //     productWithImage.image = ""; // Si falla la llamada, usar la imagen por defecto
      //   }
      // }

      setCartItems((prevItems) => {
        // Buscar si el producto ya existe en el carrito por su `id`
        const existingProductIndex = prevItems.findIndex(
          (item) => item.id === productWithImage.id
        );

        if (existingProductIndex >= 0) {
          // Si ya existe, incrementamos la cantidad
          const updatedItems = [...prevItems];
          updatedItems[existingProductIndex].quantity += quantity;
          return updatedItems;
        } else {
          // Si no existe, lo agregamos con su cantidad inicial
          return [...prevItems, { ...productWithImage, quantity }];
        }
      });
    } catch (error) {
      console.error("Error al agregar el producto al carrito:", error);
    }
  };

  const removeFromCart = (productId: number) => {
    setCartItems((prevItems) =>
      prevItems.filter((item) => item.id !== productId)
    );
  };

  return (
    <CartContext.Provider value={{ cartItems, addToCart, removeFromCart,setCartItems }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = (): CartContextType => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart debe ser utilizado dentro de un CartProvider");
  }
  return context;
};
